/*!
 * vue-bem-styled-tag v0.10.1 
 * (c) 2020 Alex Tkachenko
 * Released under the MIT License.
 */
import { BLOCK_MODIFIERS, BLOCK_STATES, extractProps, constructProps, MODIFIER_PROP_DEFINITION, STATE_PROP_DEFINITION, StylingPropsMixin } from '@aspectus/vue-bem-styling';
import { mergeContext } from '@aspectus/vue-utils';

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function prepareResolver() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$modifiers = options.modifiers,
      modifiers = _options$modifiers === void 0 ? {} : _options$modifiers,
      _options$states = options.states,
      states = _options$states === void 0 ? {} : _options$states;
  var allModifiers = Object.assign({}, BLOCK_MODIFIERS, modifiers);
  var allStates = Object.assign({}, BLOCK_STATES, states);
  var modifiersExtractor = extractProps(allModifiers);
  var statesExtractor = extractProps(allStates);
  return function (props) {
    return [modifiersExtractor(props), statesExtractor(props)];
  };
}
function prepareProps() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$modifiers = _ref.modifiers,
      modifiers = _ref$modifiers === void 0 ? {} : _ref$modifiers,
      _ref$states = _ref.states,
      states = _ref$states === void 0 ? {} : _ref$states,
      _ref$props = _ref.props,
      props = _ref$props === void 0 ? {} : _ref$props;

  return Object.assign({}, constructProps(modifiers, MODIFIER_PROP_DEFINITION), constructProps(states, STATE_PROP_DEFINITION), props);
}
function generator() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$tag = options.tag,
      tag = _options$tag === void 0 ? 'div' : _options$tag,
      block = options.block,
      state = options.state,
      _options$transform = options.transform,
      transform = _options$transform === void 0 ? null : _options$transform,
      _options$children = options.children,
      children = _options$children === void 0 ? null : _options$children;
  var resolver = prepareResolver(options);
  return {
    functional: true,
    mixins: [StylingPropsMixin],
    props: prepareProps(options),
    render: function render(h, context) {
      var props = transform ? transform(context.props) : context.props;

      var _resolver = resolver(props),
          _resolver2 = _slicedToArray(_resolver, 2),
          currentModifiers = _resolver2[0],
          currentStates = _resolver2[1];

      return h(tag, mergeContext(context.data, {
        class: [block(currentModifiers), state ? state(currentStates) : null]
      }), children ? children(h, context, options) : context.children);
    }
  };
}

export { generator, prepareProps, prepareResolver };
